import React from "react";
import { useTranslation } from "react-i18next";
import { Calculator } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { useMoneyCycleData } from "../data/moneyCycle.selectors";
import { useCurrency } from "../contexts/CurrencyContext";
import CurrencySelector from "./CurrencySelector";
import AlternativeMoneyCycleChart from "./AlternativeMoneyCycleChart";

// Alternative Money Cycle Module - Card-based Dashboard
const AlternativeMoneyCycleModule = ({ onNavigate }) => {
  const { t } = useTranslation();
  const { data, loading } = useMoneyCycleData();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading your money cycle...</p>
        </div>
      </div>
    );
  }

  // Show prompt if no My Numbers data
  if (!data.hasData) {
    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-white">{t('moneyCycle.title')}</h2>
            <p className="text-gray-400">{t('moneyCycle.cardBasedDashboard')}</p>
          </div>
          <CurrencySelector />
        </div>
        
        <Card className="border-2 border-dashed border-purple-300 bg-purple-50">
          <CardContent className="py-12">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 mx-auto bg-purple-100 rounded-full flex items-center justify-center">
                <Calculator className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-purple-800">{t('moneyCycle.completeNumbersFirst')}</h3>
              <p className="text-purple-700 max-w-md mx-auto">
                {t('moneyCycle.requiresData')}
              </p>
              <Button 
                onClick={() => onNavigate && onNavigate('mynumbers')}
                className="bg-purple-600 hover:bg-purple-700 text-white"
              >
                {t('moneyCycle.goToMyNumbers')}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header with Currency Selector */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">{t('moneyCycle.title')}</h2>
          <p className="text-gray-400">{t('moneyCycle.cardBasedDashboard')}</p>
        </div>
        <CurrencySelector />
      </div>

      {/* Alternative Money Cycle Chart - Card Based */}
      <AlternativeMoneyCycleChart 
        {...data} 
      />
    </div>
  );
};

export default AlternativeMoneyCycleModule;
